import ErrorPage from './src/ErrorPage.vue'

ErrorPage.install = function(Vue) {
  Vue.component(ErrorPage.name, ErrorPage)
}

export default ErrorPage
